<script>
export default {
  name: 'YoutubeVideo',
}
</script>

<script setup>
import { SecondaryButton } from "@codinglabsau/ui"
import { NodeViewWrapper, nodeViewProps } from "@tiptap/vue-3"
import useNodeProps from "@/Composables/useNodeProps"
import EditYoutubeVideo from "./../../Modals/EditYoutubeVideo.vue"
import EditableNode from "./../../Components/EditableNodeWrapper.vue"

const props = defineProps({
  ...nodeViewProps,
})
let { src, title, height, width, justify } = useNodeProps(props)

const addYoutubeLink = () => {
  const url = window.prompt('Please enter a valid Youtube URL.')

  if (url) {
    const youtubeUrlPattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/;

    const match = url.match(youtubeUrlPattern)

    if (match){
      src.value = `https://www.youtube.com/embed/${match[1]}`
    } else {
      alert(__('Could not detect video, Please enter a valid Youtube URL.'))
    }
  }
}
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditYoutubeVideo
          v-model:title="title"
          v-model:height="height"
          v-model:width="width"
          v-model:justify="justify"
        />
      </template>
      <template #content>
        <div v-if="src" :class="['flex justify-' + justify]" data-youtube-video>
          <iframe
            :src="src"
            :width="width"
            :height="height"
            :title="title"
            allowfullscreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          />
        </div>
        <div v-else class="flex flex-col mx-auto justify-center w-fit p-3">
          <div class="mx-auto">
            <svg viewBox="0 0 16 16" class="w-10 h-10 text-gray-400" fill="currentColor">
              <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>
            </svg>
          </div>
          <div class="text-center text-sm text-gray-500">
            <p>{{ __('No video') }}</p>
          </div>
          <div class="mx-auto my-2">
            <SecondaryButton
              as="button"
              @click.prevent="addYoutubeLink"
              class="border-3 border-indigo-600 text-indigo-600"
            >
              {{ __('Add youtube link') }}
            </SecondaryButton>
          </div>
        </div>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
